import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

const videoAttrs = {
  loop: true,
  autoPlay: true,
  playsInline: true
};

export const Wrapper = styled.div`
  ${flexCenter};
  flex-direction: column;
  flex-wrap: wrap;
  margin: 0 auto;
  height: 100%;
`;

export const VideoWrapper = styled.video.attrs(videoAttrs)`
  max-width: 320px;
  margin-bottom: 32px;
`;

export const MessageWrapper = styled.p`
  font-weight: 700;
  font-size: 21px;
  line-height: 29px;
  text-align: center;
  color: #292a2b;
  margin: 0;
`;
